// import React, { useState, useEffect } from "react";
// import Table from "react-bootstrap/Table";

// import { useNavigate } from "react-router-dom";
// import "./ApplicationManagement.css";
// import NavigationBar from "../../Components/NavigationBar";

// export default function SendCompletedApplications() {

//   const [applications, setApplications] = useState([]);
//   const [currentAppID, setCurrentAppID] = useState(null);
//   const navigate = useNavigate();

//   // Fetch applications from the backend
//   useEffect(() => {
//     fetch("http://localhost:5000/api/apcPaymentReceived")
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Fetched Data:", data); // Log the API response
//         if (Array.isArray(data)) {
//           setApplications(data);
//         } else {
//           console.error("API did not return an array:", data);
//         }
//       })
//       .catch((error) => console.error("Error fetching applications:", error));
//   }, []);

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-name">APC Completed Applications - Send for Bursar</h1>
//       <Table
//         striped
//         bordered
//         hover
//         style={{
//           marginTop: "20px",
//           boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <thead>
//           <tr>
//             <th>Application Id</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>Status</th>

//             <th>Downlaod Payment Documents</th>
//             <th>Application</th>
//             <th>Select Application</th>
//           </tr>
//         </thead>
//         <tbody>
//   {Array.isArray(applications) &&
//     applications.map((app) => (
//       <tr key={app.Application_Id}>
//         <td>{app.Application_Id}</td>
//         <td>{app.Award_Type}</td>
//         <td>{app.SubmittedDate}</td>
//         <td>{app.Status}</td>

//        <td>
//                 {app.Payment_Receipt_Receive === 1 ? (
//                   <button
//                     className="View_Button"
//                     onClick={() => {
//                       const fileName = `${app.Application_Id}_PaymentReceipt.pdf`;
//                       const fileUrl = `http://localhost:5000/APCPaymentReceipt/${fileName}`;
//                       window.open(fileUrl, "_blank");
//                     }}
//                   >
//                     Download
//                   </button>
//                 ) : (
//                   <span style={{ color: "gray" }}>Not available</span>
//                 )}
//               </td>

//         <td>
//           <button
//             className="View_Button"
//             onClick={() => {
//               const formattedAwardType = app.Award_Type.replace(/\s+/g, "_");
//               const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//               const fileUrl = `http://localhost:5000/ApplicationForms/${fileName}`;
//               window.open(fileUrl, "_blank");
//             }}
//           >
//             View
//           </button>
//         </td>
//       </tr>
//     ))}
// </tbody>

//       </Table>

//       {/* Modal for selecting shortlist or rejection */}

//     </div>
//   );
// }
// import React, { useState, useEffect } from "react";
// import Table from "react-bootstrap/Table";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import { useNavigate } from "react-router-dom";
// import "./ApplicationManagement.css";
// import NavigationBar from "../../Components/NavigationBar";
// import { FaPaperPlane } from "react-icons/fa";

// export default function SendCompletedApplications() {
//   const [applications, setApplications] = useState([]);
//   const [selectedApps, setSelectedApps] = useState([]);
//   const navigate = useNavigate();

//   // Fetch applications from the backend
//   useEffect(() => {
//     fetch("http://localhost:5000/api/apcPaymentReceived")
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Fetched Data:", data);
//         if (Array.isArray(data)) {
//           setApplications(data);
//         } else {
//           console.error("API did not return an array:", data);
//         }
//       })
//       .catch((error) => console.error("Error fetching applications:", error));
//   }, []);

//   const handleSelectApp = (appId) => {
//     setSelectedApps(prev =>
//       prev.includes(appId)
//         ? prev.filter(id => id !== appId)
//         : [...prev, appId]
//     );
//   };

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       setSelectedApps(applications.map(app => app.Application_Id));
//     } else {
//       setSelectedApps([]);
//     }
//   };

//   const handleSendEmail = () => {
//     if (selectedApps.length === 0) {
//       alert("Please select at least one application");
//       return;
//     }
//     console.log("Sending emails for:", selectedApps);
//     // Add your email sending logic here
//     alert(`Emails will be sent for ${selectedApps.length} selected applications`);
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h1 className="page-name">APC Completed Applications - Send for Bursar</h1>
//         <Button
//           variant="primary"
//           onClick={handleSendEmail}
//           disabled={selectedApps.length === 0}
//         >
//           <FaPaperPlane className="me-2" />
//           Send Email ({selectedApps.length})
//         </Button>
//       </div>

//       <Table striped bordered hover style={{ marginTop: "20px", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}>
//         <thead>
//           <tr>
//             <th>
//               <Form.Check
//                 type="checkbox"
//                 onChange={handleSelectAll}
//                 checked={selectedApps.length === applications.length && applications.length > 0}
//               />
//             </th>

//             <th>Application Id</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>Status</th>
//             <th>Download Payment Documents</th>
//             <th>Application</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Array.isArray(applications) &&
//             applications.map((app) => (
//               <tr key={app.Application_Id}>
//                 <td>
//                   <Form.Check
//                     type="checkbox"
//                     checked={selectedApps.includes(app.Application_Id)}
//                     onChange={() => handleSelectApp(app.Application_Id)}
//                   />
//                 </td>
//                 <td>{app.Application_Id}</td>
//                 <td>{app.Award_Type}</td>
//                 <td>{app.SubmittedDate}</td>
//                 <td>{app.Status}</td>
//                 <td>
//                   {app.Payment_Receipt_Receive === 1 ? (
//                     <Button
//                       variant="outline-primary"
//                       className="View_Button"
//                       size="sm"
//                       onClick={() => {
//                         const fileName = `${app.Application_Id}_PaymentReceipt.pdf`;
//                         const fileUrl = `http://localhost:5000/APCPaymentReceipt/${fileName}`;
//                         window.open(fileUrl, "_blank");
//                       }}
//                     >
//                       Download
//                     </Button>
//                   ) : (
//                     <span style={{ color: "gray" }}>Not available</span>
//                   )}
//                 </td>
//                 <td>
//                   <Button
//                     variant="outline-primary"
//                     className="View_Button"
//                     size="sm"
//                     onClick={() => {
//                       const formattedAwardType = app.Award_Type.replace(/\s+/g, "_");
//                       const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//                       const fileUrl = `http://localhost:5000/ApplicationForms/${fileName}`;
//                       window.open(fileUrl, "_blank");
//                     }}
//                   >
//                     View
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//         </tbody>
//       </Table>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import Table from "react-bootstrap/Table";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import { useNavigate } from "react-router-dom";
// import "./ApplicationManagement.css";
// import NavigationBar from "../../Components/NavigationBar";
// import { FaPaperPlane } from "react-icons/fa";

// export default function SendCompletedApplications() {
//   const [applications, setApplications] = useState([]);
//   const [selectedApps, setSelectedApps] = useState([]);
//   const navigate = useNavigate();

//   // Fetch applications from the backend
//   useEffect(() => {
//     fetch("http://localhost:5000/api/apcPaymentReceived")
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Fetched Data:", data);
//         if (Array.isArray(data)) {
//           setApplications(data);
//         } else {
//           console.error("API did not return an array:", data);
//         }
//       })
//       .catch((error) => console.error("Error fetching applications:", error));
//   }, []);

//   const handleSelectApp = (appId) => {
//     setSelectedApps(prev =>
//       prev.includes(appId)
//         ? prev.filter(id => id !== appId)
//         : [...prev, appId]
//     );
//   };

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       setSelectedApps(applications.map(app => app.Application_Id));
//     } else {
//       setSelectedApps([]);
//     }
//   };

//   const handleSendEmail = () => {
//     if (selectedApps.length === 0) {
//       alert("Please select at least one application");
//       return;
//     }

//     // Get the selected applications' data
//     const selectedApplicationsData = applications.filter(app =>
//       selectedApps.includes(app.Application_Id)
//     );

//     // Navigate to SendEmailBursar with all selected applications
//     navigate("/sendemailbursar", {
//       state: {
//         selectedApplications: selectedApplicationsData,
//         // You can add other default values here
//       }
//     });
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h1 className="page-name">APC Completed Applications - Send for Bursar</h1>
//         <Button
//           variant="primary"
//           onClick={handleSendEmail}
//           disabled={selectedApps.length === 0}
//         >
//           <FaPaperPlane className="me-2" />
//           Send Email ({selectedApps.length})
//         </Button>
//       </div>

//       <Table striped bordered hover style={{ marginTop: "20px", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}>
//         <thead>
//           <tr>
//             <th>
//               <Form.Check
//                 type="checkbox"
//                 onChange={handleSelectAll}
//                 checked={selectedApps.length === applications.length && applications.length > 0}
//               />
//             </th>
//             <th>Application Id</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>Status</th>
//             <th>Download Payment Documents</th>
//             <th>Application</th>
//             <th>Email (✅/❌)</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Array.isArray(applications) &&
//             applications.map((app) => (
//               <tr key={app.Application_Id}>
//                 <td>
//                   <Form.Check
//                     type="checkbox"
//                     checked={selectedApps.includes(app.Application_Id)}
//                     onChange={() => handleSelectApp(app.Application_Id)}
//                   />
//                 </td>
//                 <td>{app.Application_Id}</td>
//                 <td>{app.Award_Type}</td>
//                 <td>{app.SubmittedDate}</td>
//                 <td>{app.Status}</td>
//                 <td>
//                   {app.Payment_Receipt_Receive === 1 ? (
//                     <Button
//                       variant="outline-primary"
//                       className="View_Button"
//                       size="sm"
//                       onClick={() => {
//                         const fileName = `${app.Application_Id}_PaymentReceipt.pdf`;
//                         const fileUrl = `http://localhost:5000/APCPaymentReceipt/${fileName}`;
//                         window.open(fileUrl, "_blank");
//                       }}
//                     >
//                       Download
//                     </Button>
//                   ) : (
//                     <span style={{ color: "gray" }}>Not available</span>
//                   )}
//                 </td>
//                 <td>
//                   <Button
//                     variant="outline-primary"
//                     className="View_Button"
//                     size="sm"
//                     onClick={() => {
//                       const formattedAwardType = app.Award_Type.replace(/\s+/g, "_");
//                       const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//                       const fileUrl = `http://localhost:5000/ApplicationForms/${fileName}`;
//                       window.open(fileUrl, "_blank");
//                     }}
//                   >
//                     View
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//         </tbody>
//       </Table>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";
import { FaPaperPlane } from "react-icons/fa";

export default function SendCompletedApplications() {
  const [applications, setApplications] = useState([]);
  const [selectedApps, setSelectedApps] = useState([]);
  const [bursarStatus, setBursarStatus] = useState({});
  const [selectedYear, setSelectedYear] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';

  // Fetch applications from the backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Fetch applications
        const appsResponse = await fetch(`${API_BASE_URL}/apcPaymentReceived`);
        const appsData = await appsResponse.json();

        if (Array.isArray(appsData)) {
          setApplications(appsData);

          // Fetch bursar status for these applications
          const appIds = appsData.map((app) => app.Application_Id);
          if (appIds.length > 0) {
            const statusResponse = await fetch(
              `${API_BASE_URL}/getBursarEmailDetails?appIds=${appIds.join(",")}`
            );
            const statusData = await statusResponse.json();

            // Create a map of App_Id to Sent status (1 or 0)
            const statusMap = {};
            statusData.forEach((item) => {
              statusMap[item.Application_Id] = item.Sent === 1;
            });
            setBursarStatus(statusMap);
          }
        } else {
          console.error("API did not return an array:", appsData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  // Check if email was sent for a specific application
  const isEmailSent = (appId) => {
    return bursarStatus[appId] === true;
  };

  // Handle selecting an application
  const handleSelectApp = (appId) => {
    setSelectedApps((prev) =>
      prev.includes(appId)
        ? prev.filter((id) => id !== appId)
        : [...prev, appId]
    );
  };

  // Handle select all checkbox
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedApps(filteredApplications.map((app) => app.Application_Id));
    } else {
      setSelectedApps([]);
    }
  };

  // Handle sending email
  const handleSendEmail = () => {
    if (selectedApps.length === 0) {
      alert("Please select at least one application");
      return;
    }

    const selectedApplicationsData = filteredApplications.filter((app) =>
      selectedApps.includes(app.Application_Id)
    );

    navigate("/sendemailbursar", {
      state: {
        selectedApplications: selectedApplicationsData,
      },
    });
  };

  // Generate years from 2024 to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected year
  const filteredApplications = applications.filter((app) => {
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesYear;
  });

  if (loading) {
    return <div>Loading applications...</div>;
  }

  return (
    <div >
      <NavigationBar />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem", maxWidth: "100%" }}>
        <h1 className="page-name" style={{ margin: 0, textAlign: "left", flex: "1 1 auto" }}>
          APC Completed Applications - Send for Bursar
        </h1>
        <Button
          variant="primary"
          onClick={handleSendEmail}
          disabled={selectedApps.length === 0}
          style={{ marginRight: "40px", flex: "0 0 auto" , marginTop: "10px"}}
        >
          <FaPaperPlane className="me-2" />
          Send Email ({selectedApps.length})
        </Button>
      </div>

      <div style={{ margin: "20px 0", display: "flex", gap: "20px", fontWeight: "bold" }}>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Years</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>

      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>
              <Form.Check
                type="checkbox"
                onChange={handleSelectAll}
                checked={
                  selectedApps.length === filteredApplications.length &&
                  filteredApplications.length > 0
                }
              />
            </th>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Download Payment Documents</th>
            <th>Application</th>
            <th>Email</th>
            <th>Bursar Decision</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) &&
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedApps.includes(app.Application_Id)}
                    onChange={() => handleSelectApp(app.Application_Id)}
                  />
                </td>
                <td>{app.Applicant_Name || app.Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  {(app.Payment_Receipt_Receive ?? 0) === 1 ? (
                    <Button
                      variant="outline-primary"
                      className="View_Button"
                      size="sm"
                      onClick={() => {
                        const fileName = `${app.Application_Id}_PaymentReceipt.pdf`;
                        const fileUrl = `${FILE_BASE_URL}/api/Uploads/APCPaymentReceipt/${fileName}`;
                        window.open(fileUrl, "_blank");
                      }}
                    >
                      Download
                    </Button>
                  ) : (
                    <span style={{ color: "gray" }}>Not available</span>
                  )}
                </td>
                <td>
                  <Button
                    variant="outline-primary"
                    className="View_Button"
                    size="sm"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </Button>
                </td>
                <td>
                  {isEmailSent(app.Application_Id) ? (
                    <span className="emailsent">✅</span>
                  ) : (
                    <span className="emailsent">❌</span>
                  )}
                </td>
                <td>
                  {app.Status === "Accepted" ? (
                    <label className="approve-label">Accepted</label>
                  ) : app.Status === "Declined" ? (
                    <label className="reject-label">Decline</label>
                  ) : (
                    <label className="pending-label">⏳ Pending</label>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}